import { render, staticRenderFns } from "./DisputeFee.vue?vue&type=template&id=765c6d5e&scoped=true&"
import script from "./DisputeFee.vue?vue&type=script&lang=js&"
export * from "./DisputeFee.vue?vue&type=script&lang=js&"
import style0 from "./DisputeFee.vue?vue&type=style&index=0&id=765c6d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765c6d5e",
  null
  
)

export default component.exports